import { Component, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { PowerFactor } from './power-factor.model';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-power-factor',
  imports: [FormField, MatInputModule, MatButtonToggleModule],
  templateUrl: './power-factor.component.html',
  styles: ``,
})
export class PowerFactorComponent {

  readonly form = input.required<FieldTree<PowerFactor>>();

}
